import _default from './Table';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/collections/Table/index.js
// module id = 864
// module chunks = 0